import { globalStyle, style } from '@vanilla-extract/css';
import { recipe } from '@vanilla-extract/recipes';

export const codeBlock = style({
  backgroundColor: 'var(--wt-code-block-background-color)',
  padding: 'var(--wt-padding)',
  textAlign: 'left',
});

export const preWrapper = style({
  position: 'relative',
  borderRadius: 'var(--wt-border-radius)',
  overflow: 'hidden',
});

export const copyButton = style({
  position: 'absolute',
  top: '8px',
  right: '8px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '6px',
  borderRadius: '6px',
  border: 'none',
  cursor: 'pointer',
  color: 'rgba(255, 255, 255, 0.4)',
  background: 'rgba(255, 255, 255, 0.05)',
  transition: 'background 0.15s ease',
  selectors: {
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.1)',
      color: '#FFFFFF',
    },
  },
});

export const pre = recipe({
  base: {
    background: '#282828',
    color: '#FFFFFF',
    lineHeight: 1.5,
  },
  variants: {
    horizontallyScrollable: {
      true: {
        overflowX: 'auto',
        scrollbarColor: 'gray #282828',
        scrollbarWidth: 'thin',
      },
      false: {},
    },
  },
  defaultVariants: {
    horizontallyScrollable: true,
  },
});

globalStyle(`${pre.classNames.base} > code`, {
  display: 'block',
  padding: '16px',
});

globalStyle(`${pre.classNames.variants.horizontallyScrollable.true} > code`, {
  display: 'inline-block',
  boxSizing: 'border-box',
  minWidth: '100%',
  whiteSpace: 'pre !important',
});

globalStyle(`${pre.classNames.variants.horizontallyScrollable.false} > code`, {
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word',
  wordBreak: 'break-word',
});

// highlight.js sets background/color on .hljs — reset to inherit so the WYSIWYG
// editor (which passes <code class="hljs"> as children) matches web/email rendering.
globalStyle(`${pre.classNames.base} code.hljs`, {
  background: 'inherit',
  color: 'inherit',
});
